export default __webpack_public_path__ + "static/media/okra.9edc9987.png";